import { useAuth } from '@/lib/auth/auth';
import { dashboardKeys, followingFeedKeys, nearbyFeedKeys } from '@/features/events/feed/feedQuery';
import type { CancelEventRequest } from '@/lib/api/apiTypes';
import { editableEventKeys } from '@/features/events/useEditableEvent';
import { eventDetailKeys } from '@/features/events/useEventDetail';
import { notificationKeys } from '@/features/pulse/useNotifications';
import { venueEventKeys } from '@/features/venues/useVenueEvents';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCancelEvent() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      eventID,
      message,
      venueID,
    }: {
      eventID: string;
      message?: string | null;
      venueID?: string | null;
    }) => {
      const payload: CancelEventRequest = {
        message: message?.trim() ? message.trim() : null,
      };

      void venueID;

      return request<void>(`/events/${eventID}/cancel`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: eventDetailKeys.byId(variables.eventID) }),
        queryClient.invalidateQueries({ queryKey: nearbyFeedKeys.all }),
        queryClient.invalidateQueries({ queryKey: followingFeedKeys.all }),
        queryClient.invalidateQueries({ queryKey: dashboardKeys.current() }),
        queryClient.invalidateQueries({ queryKey: editableEventKeys.all }),
        queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
        variables.venueID
          ? queryClient.invalidateQueries({ queryKey: venueEventKeys.list(variables.venueID) })
          : Promise.resolve(),
      ]);
    },
  });
}
